export default __webpack_public_path__ + "images/2bea2104f769c4efe7c0b6e6a1ec92e2-sports.png";